import React from 'react'
import  { CircularProgress, Grid } from '@mui/material'
import { useSelector } from 'react-redux';
import Post from './Post/Post'
import useStyles from './style';


const Posts = ({ setCurrentId }) => {
  const {posts, isLoading} = useSelector((state) => state.posts); 
  const classes = useStyles();

  if(!posts.length && !isLoading) return 'NO Posts';

  return (
      isLoading ? <CircularProgress /> : (
        <Grid className={classes.container} container alignItems='stretch' spacing={3}>
          {posts.map((post)=>(
            <Grid key={post._id} item xs={12} sm={6}>
              <Post post={post} setCurrentId={setCurrentId} />
            </Grid>
          ))}
        </Grid>
      )
  )
}

export default Posts
